import { render, staticRenderFns } from "./LeadNew.vue?vue&type=template&id=9d167f6e&"
import script from "./LeadNew.vue?vue&type=script&lang=js&"
export * from "./LeadNew.vue?vue&type=script&lang=js&"
import style0 from "./LeadNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports